import type { MetaAddonsType } from '@/hooks/useAddonsMeta';
import { EnabledAddonsType } from '@/hooks/useListEnabledAddons';
import { atom } from 'jotai';

export const selectedAddonsAtom = atom({
  selectedAddonsMeta: undefined as MetaAddonsType | undefined,
  selectedEnabledAddons: undefined as EnabledAddonsType | undefined,
});
